import productFaqHtml from './productfaq.component.html';

class ProductFaqController {
    constructor($scope, ModalService) {
        'ngInject';

        this.$scope = $scope;
        this.ModalService = ModalService;
    }

    ask() {
        const modalRef = this.ModalService.add(
            `Zadaj pytanie o produkt ${this.product.name}`,
            `<product-faq-ask product-id="${this.product.id}" product-name="'${this.product.name}'" user-is-logged-in="${this.userIsLoggedIn}"></product-faq-ask>`,
            null,
            false
        );

        modalRef.open();
    }
}

let productFaqComponent = {
    bindings: {
        product: '<',
        userIsLoggedIn: '<'
    },
    template: productFaqHtml,
    controller: ProductFaqController
};

export default productFaqComponent;
